/**
 * Core Web Vitals reporting and performance tracking
 */

import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';
import type { Metric } from 'web-vitals';
import { track } from './core';

export function trackError(params: {
  error_type: string;
  error_message: string;
  error_location?: string;
  fatal?: boolean;
}): void {
  track('exception', {
    description: `${params.error_type}: ${params.error_message}`,
    fatal: params.fatal || false,
    error_location: params.error_location,
  });
}

export function trackWebVitals(params: {
  metric_name: 'LCP' | 'FID' | 'CLS' | 'TTFB' | 'FCP' | 'INP';
  metric_value: number;
  metric_rating: 'good' | 'needs-improvement' | 'poor';
}): void {
  track('web_vitals', {
    ...params,
    event_category: 'Web Vitals',
    event_label: params.metric_name,
    value: Math.round(params.metric_value),
  });
}

export function trackAnalysisPerformance(params: {
  word_count: number;
  analysis_time_ms: number;
  ml_enabled: boolean;
}): void {
  track('timing_complete', {
    name: 'analysis',
    value: params.analysis_time_ms,
    event_category: 'Performance',
    event_label: params.ml_enabled ? 'with_ml' : 'without_ml',
  });
}

function reportMetric(metric: Metric): void {
  trackWebVitals({
    metric_name: metric.name as 'LCP' | 'FID' | 'CLS' | 'TTFB' | 'FCP' | 'INP',
    metric_value: metric.value,
    metric_rating: metric.rating,
  });
}

export function observeWebVitals(): () => void {
  onCLS(reportMetric, { reportAllChanges: true });
  onINP(reportMetric);
  onLCP(reportMetric);
  onFCP(reportMetric);
  onTTFB(reportMetric);

  return () => {};
}
